module.exports = __webpack_public_path__ + "img/logo_gov_ma.de93a799.jpeg";